import { render, staticRenderFns } from "./TheBanner.vue?vue&type=template&id=d1cb7122&scoped=true"
var script = {}
import style0 from "./TheBanner.vue?vue&type=style&index=0&id=d1cb7122&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1cb7122",
  null
  
)

export default component.exports